<template>
  <UIDropdown :container :placement :disabled>
    <template #default="{ toggle }">
      <slot v-bind="{ toggle }" />
    </template>
    <template #popper="{ hide }">
      <div class="ui-dropdown-confirm">
        <span>{{ message }}</span>
        <div class="ui-dropdown-confirm__buttons">
          <UIButton
            label="Yes"
            variant="danger"
            size="xs"
            @click="handleConfirm(hide)"
          />
          <UIButton
            label="No"
            variant="secondary"
            size="xs"
            @click="hide"
          />
        </div>
      </div>
    </template>
  </UIDropdown>
</template>

<script setup lang="ts">
import { Placement } from 'floating-vue'

import UIDropdown from './Dropdown.vue'
import UIButton from '../Button/Button.vue'

type Props = {
  message: string

  disabled?: boolean

  container?: string
  placement?: Placement
}

type Emits = {
  'confirm': [callback: () => void]
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const handleConfirm = (hide: () => void) => {
  emit('confirm', hide)
}
</script>

<style>
.ui-dropdown-confirm {
  @apply w-64;
  @apply p-2;
  @apply text-sm sm:text-xs;
  @apply text-light-text;
  @apply text-center;

  &__buttons {
    @apply flex justify-center;
    @apply gap-2;
    @apply pt-2;
  }
}
</style>
